import {
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const InvestorsCornerCommonFormFields = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* Common Section Form Fields */}
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Common Banner Image"
              fieldId="investors-corner-common-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange(
                      "investors-corner-common-banner-image",
                      id
                    )
                  : handleImageChange(
                      "investors-corner-common-banner-image",
                      ""
                    )
              }
              selectedFileId={
                formData?.["investors-corner-common-banner-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Common Banner Heading"
            fieldId="investors-corner-common-banner-heading"
            fieldName="investors-corner-common-banner-heading"
            placeholderText="Heading"
            inputValue={
              formData?.["investors-corner-common-banner-heading"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Common Banner Description"
            fieldId="investors-corner-common-banner-heading"
            fieldName="investors-corner-common-banner-description"
            placeholderText="Description"
            inputValue={
              formData?.["investors-corner-common-banner-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Tabs */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            labelText="Main Tabs"
            fieldId="investors-corner-common-tabs"
            handleTextInputChange={handleTextInputChange}
            // handleTextEditorInputChange={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "investors-corner-tab-card-1",
                types: ["TEXT", "TEXT", "TEXT"],
                is_hidden: [true, true, true],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "investors-corner-tab-label-1",
                text_filed_id_2: "investors-corner-tab-label-2",
                text_filed_id_3: "investors-corner-tab-label-3",
                // Placeholders
                text_filed_placeholder_1: "Tab Name 1",
                text_filed_placeholder_2: "Tab Name 2",
                text_filed_placeholder_3: "Tab Name 3",
              },
            ]}
          />
        </>
      )}
    </>
  );
};

export default InvestorsCornerCommonFormFields;
